// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xPHC","content":"styles_content__36E7I","row":"styles_row__3v0iW","footer":"styles_footer__2lK6l","phraseLength":"styles_phraseLength__2624D"};